import FooterControl from '@/components/FooterControl.vue';
import record from '@/components/record.vue';
import { PAGE_STAY_COUNT, pageSizes } from '@/config/constant';
import { currentDate } from '@/utils/filter';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import { REG_AMT } from '@/utils/validate/regExp';

export default {
  name: '',
  components: { FooterControl, record, HisAutocompleteSuggestions },
  data() {
    return {
      value: '',
      input5: '',
      options: [],
      selectTableOptions: [],
      inputDisabled: false,
      form: {
        supplier: '',
        remark: '',
        createDate: currentDate,
        batchInstockId: '',
        instockType: '',
      },
      beforePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableData: [],
      historyList: [],
      options1: [{
        value: 1,
        label: '采购退货',
      }, {
        value: 6,
        label: '调拨出库',
      }, {
        value: 7,
        label: '报损出库',
      }, {
        value: 8,
        label: '其他出库',
      }],
      showConSaveBtn: true,
      showSaveBtn: true,
      showConBtn: false,
      isDisable: false, // 是否禁用提交按钮
      model: '',
      query: {
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      total: 0,
      pageSizes,
      batchNo: this.$route.query.id || '',
      totalPrices: 0,
    };
  },
  methods: {
    // 每页展示数据条数变更
    handleSizeChange(e) {
      this.query.pageSize = e;
      this.getDetailList(1);
    },
    // 翻页
    handleCurrentChange(e) {
      this.query.currentPage = e;
      this.getDetailList();
    },
    // 批次详情列表-分页
    getDetailList(type) {
      if (type === 1) {
        this.query.currentPage = 1;
      }
      this.batchNo = this.$route.query.id;
      this.$api.drugControl.detailList({ batchInstockId: this.batchNo, ...this.query })
        .then((res) => {
          this.tableData = res.list.map((item) => {
            return {
              ...item,
              drugSalePrice: item.salePrice,
              curInput: item.drugName,
            };
          }) || [];
          this.total = res.totalSize;
        });
    },
    curModel() {
      const {
        state,
        id,
      } = this.$route.query;
      this.model = state;
      switch (state) {
        case 'add':
          this.addDrug();
          break;
        case 'addValidity':
          this.addDrugFromValidity();
          break;
        case 'edit':
          this.form.batchInstockId = id;
          this.getDetail();
          break;
        case 'confirm':
          this.form.batchInstockId = id;
          this.inputDisabled = true;
          this.showConBtn = true;
          this.showConSaveBtn = false;
          this.showSaveBtn = false;
          this.getDetail();
          // this.getDetailList(1);
          break;
        default:
          break;
      }
    },
    // 确认
    confirm() {
      this.$api.drugControl.outStockConfirm({ batchInstockId: this.form.batchInstockId })
        .then(() => {
          this.$message({
            message: '确认出库成功！',
            type: 'success',
          });
          this.goBack();
        });
    },
    save(type) {
      if (this.form.createDate === '') {
        this.$message({
          message: '请选择出库日期！',
          type: 'warning',
        });
        return;
      }
      if (this.form.instockType === '') {
        this.$message({
          message: '请选择出库类型！',
          type: 'warning',
        });
        return;
      }
      let instockDrugList = this.tableData.filter(ele => ele.drugId);
      // 验证药品名称是否填写正确
      const valiDrugName = instockDrugList.some(item => !item.drugName || item.drugName !== item.curInput);
      if (valiDrugName) {
        this.$message({
          message: '请输入正确的药品名！',
          type: 'warning',
        });
        return;
      }
      // 验证入库数量
      const reg = /^[0-9]*[1-9][0-9]*$/;
      const valiDrugCount = instockDrugList.some(item => !reg.test(item.instockCount));
      if (valiDrugCount) {
        this.$message({
          message: '请输入正整数的入库数量！',
          type: 'warning',
        });
        return;
      }
      instockDrugList = instockDrugList.map(item => ({
        drugBatchNo: item.drugBatchNo || '',
        drugId: item.drugId,
        instockCount: item.instockCount,
        instockUnit: item.instockUnit,
        validityDate: item.validityDate || '',
        purchasePrice: item.purchasePrice || 0,
        outOfStockId: item.outOfStockId,
        specification: item.specification || '', // 规格
        warehousingIdList: item.warehousingIdList || null,
      }));
      this.isDisable = true;
      this.$api.drugControl.outOfStockOperation({
        opType: type,
        outStockDrug: instockDrugList,
        totalPrice: this.totalPrice,
        orderId: this.$route.query.id,
        ...this.form,
      }).then(() => {
        this.$message({
          message: '保存成功！',
          type: 'success',
        });
        setTimeout(() => {
          this.$router.go(-1);
          this.isDisable = false;
        }, PAGE_STAY_COUNT);
      }).catch(() => {
        this.isDisable = false;
      });
    },
    addDrugFromValidity() {
      const { outOfStockId } = this.$route.query;
      this.$api.drugControl.getBatchDrugDetail({ outOfStockId }).then((res) => {
        let unitPrices = 0;
        res.drugPrices.forEach((i) => {
          if (i.unitName === res.instockUnit) {
            unitPrices = (Number(res.purchasePrice) / i.ratio).toFixed(6);
          }
        });
        this.tableData.push(
          {
            ...res,
            surplusCount: res.surplusCount,
            drugSalePrice: res.drugSalePrice,
            curInput: res.drugName,
            unitPrices,
          },
        );
      });
    },
    getDetail() {
      const { id } = this.$route.query;
      this.form.batchInstockId = id;
      this.$api.drugControl.purchasingDetail({ id }).then((res) => {
        this.form.createDate = res.createDate;
        this.form.remark = res.remark;
        this.form.supplier = res.supplier;
        this.form.instockType = res.instockType;
        this.totalPrices = res.totalPrice;
        this.tableData = res.list.map((item) => {
          let unitPrices = 0;
          item.drugPrices.forEach((i) => {
            if (i.unitName === item.instockUnit) {
              unitPrices = (Number(item.purchasePrice) / i.ratio).toFixed(6);
            }
          });
          return {
            ...item,
            instockCountN: item.instockCount,
            surplusCount: item.surplusCount,
            drugSalePrice: item.salePrice,
            curInput: item.drugName,
            unitPrices,
          };
        });
        // this.getHistory(id);
      });
    },
    getHistory(id) {
      this.$api.drugControl.instockRreturnRecord({ id })
        .then((res) => {
          this.historyList = res;
        });
    },
    returnGoods() {
      const arr = this.tableData.map((item) => {
        return {
          drugId: item.drugId,
          instockCount: item.instockCount,
          instockUnit: item.instockUnit,
          validityDate: item.validityDate,
          drugBatchNo: item.drugBatchNo,
          purchasePrice: item.purchasePrice,
          id: item.id, // 药品入库的小批次ID
        };
      });
      this.$api.drugControl.instockReturn({
        ...this.form,
        totalPrice: this.totalPrice,
        instockDrug: arr,
      }).then((res) => {
        this.goBack();
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    addDrug() {
      this.tableData.push({
        curInput: '', // 当前输入的药品名
        drugName: '',
        currentValue: '',
        specification: '', // 药品规格
        manufacturer: '', // 厂家
        drugSalePrice: '',
        purchasePrice: '',
        sugLen: 0, // 默认一个建议数据的条数 在判断药品名是否显示 警告提示的时候要用⚠
        drugPrices: [], // 单位
        popVisible: false, // tips
        visible: false, // tips
        addVisible: false,
        drugBatchNo: '', // 药品批号
      });
    },
    deleteDrug(index, item) {
      console.log(item);
      if (this.model === 'edit' && item.drugId) {
        this.$api.drugControl.instockDelete({
          batchNo: this.batchNo,
          id: item.drugId,
        }).then((res) => {
          console.log(res);
          this.tableData.splice(index, 1);
        });
      } else {
        this.tableData.splice(index, 1);
      }
    },
    // 药品选中的后将信息填入空格
    selectHandleDrug(data, index) {
      let unitPrices = 0;
      data.drugPrices.forEach((item) => {
        if (item.unitName === data.instockUnit) {
          unitPrices = (Number(data.purchasePrice) / item.ratio).toFixed(6);
        }
      });
      this.$set(this.tableData, index, {
        ...data,
        curInput: data.drugName,
        currentValue: data.drugName,
        unitPrices,
      });
      const hasNullId = this.tableData.some(ele => !ele.drugId);
      if (!hasNullId) this.addDrug();
      // 光标定位至入库数量输入框
      this.$nextTick(() => {
        document.querySelector(`.value-input-${index}`).querySelector('input').focus();
      });
    },
    // 判断当前输入药品名是否来自药品库 flag：是否删除 1正常 0 删除
    checkDrugName(name, id) {
      if (name === '' || id) return false;
      return true;
    },
    queryDrug(str, cb) {
      this.$api.drugControl.outOfStockDrugs({ drugName: str }).then((res) => {
        cb(res.outOfStockDruglist);
      }).catch(() => {
        cb([]);
      });
    },
    // 出库最大值
    maxNumber(surplusCount, drugPrices, instockUnit) {
      let max = 0;
      if (drugPrices.length <= 1) {
        max = Number(surplusCount);
      } else {
        drugPrices.forEach((item) => {
          if (item.unitName === instockUnit) {
            max = parseInt(Number(surplusCount) / item.ratio, 10);
          }
        });
      }
      return max;
    },
    // 进货价换算
    conPurchasePrice(purchasePrice, instockUnit, drugPrices, unitPrices, index) {
      let prices = 0;
      if (drugPrices.length <= 1) {
        prices = Number(purchasePrice);
      } else {
        drugPrices.forEach((item) => {
          if (item.unitName === instockUnit) {
            prices = (Number(unitPrices) * item.ratio).toFixed(3);
          }
        });
      }
      this.$set(this.tableData[index], 'purchasePrice', prices);
      return prices;
    },

  },
  computed: {
    goBackText() {
      const { state } = this.$route.query;
      if (state === 'add' || state === 'edit' || state === 'addValidity') return '取消';
      return '返回';
    },
    // 计算总价
    totalPrice() {
      const array = this.tableData.filter((item => Boolean(item.drugId)));
      const len = array.length;
      if (len === 0) return '0.00';
      const hasNaN = array.some(item => isNaN(Number(item.instockCount)) || isNaN(Number(item.purchasePrice)));
      if (hasNaN) return '0.00';
      if (len === 1) {
        const [item] = array;
        const total = Number(item.instockCount) * Number(item.purchasePrice);
        return total.toFixed(3);
      }
      const total = array.reduce((a, b) => a + (Number(b.instockCount) * Number(b.purchasePrice)), 0);
      return total.toFixed(3);
    },
    // 是否显示退货记录
    showRcord() {
      return this.historyList.length > 0;
    },
    // 退货为0则不给他退货
    disableBtn() {
      return this.tableData.every(item => item.instockCount <= 0);
    },
  },
  mounted() {
    // this.getList();
    this.curModel();
  },
};
